import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import TestRequestProcessType from "../../../../api/models/test-request/TestRequestProcessType";
import CustomDropdown, { CustomDropdownProps } from "../../../../components/Input/CustomDropdown";
import Dictionary from "../../../../models/Dictionary";

const PROCESS_TYPE_DICTIONARY: Dictionary<TestRequestProcessType> = {
  NEW: "New application process needed",
  IMPROVEMENT: "Improvement of existing solution at customer",
  INTERNAL_DEVELOPMENT_PROJECT: "Internal Development Project (NPP)",
  INTERNAL_SUPPORT: "Consultation & internal support",
};

const ProcessTypeInput: React.FC<CustomDropdownProps> = (props) => {
  return (
    <CustomDropdown {...props}>
      <MenuItem value="">
        <em>Please Choose</em>
      </MenuItem>
      {Object.keys(PROCESS_TYPE_DICTIONARY).map((pt) => (
        <MenuItem key={pt} value={pt}>
          {PROCESS_TYPE_DICTIONARY[pt as keyof Dictionary<TestRequestProcessType>]}
        </MenuItem>
      ))}
    </CustomDropdown>
  );
};

export default ProcessTypeInput;
